export const getSalesPhone = (dealerInfo: Store.Dealership): string => {
  return dealerInfo?.dealerships[0]?.phone ?? ''
}
